import request from '../../../util/SuperagentUtils';
import { inventoryCorrectionEndpoints } from '../../../requests/api-endpoints';
import { hasGateManagerAccess, hasOwnerAccess, isSupplierAccount } from "../../../util/AccountUtils";
import { getBuyerInventoryCorrectionReviewReportUrl } from './inventory-correction-params';
import { getExistingBuyerInventoryCorrectionUrl } from './existing-corrections-params';

const getAllSupplierInventoryCorrections = (
    accountId,
    query,
    onSuccess,
    onFail
) => {
    const result = request
        .get(inventoryCorrectionEndpoints.supplierSearch(accountId)).query(query);

    if (onSuccess && onFail) {
        result
            .then((resp) => onSuccess(resp.body))
            .catch((err) => onFail(err))
    } else {
        return result
    }
};

const searchBuyerInventoryCorrections = (
  accountId,
  query,
  onSuccess,
  onFail
) => {
    const result = request
      .get(getExistingBuyerInventoryCorrectionUrl(accountId, query));

    if (onSuccess && onFail) {
        result
          .then((resp) => onSuccess(resp.body))
          .catch((err) => onFail(err))
    } else {
        return result
    }
};

const searchBuyerCorrectionReview = (query, onSuccess, onFail) => {
    const result = request
      .get(getBuyerInventoryCorrectionReviewReportUrl(query));

    if (onSuccess && onFail) {
        result
          .then((resp) => onSuccess(resp.body))
          .catch((err) => onFail(err))
    } else {
        return result
    }
}

const updateInventoryCorrection = (
    inventoryId,
    data,
    onSuccess,
    onFail
) => {
    const result = request
        .patch(inventoryCorrectionEndpoints.update(inventoryId))
        .send(data)

    if (onSuccess && onFail) {
        result
            .then((resp) => onSuccess(resp.body))
            .catch((err) => onFail(err))
    } else {
        return result
    }
};

const submitInventoryCorrection = (correction, onSuccess, onFail) => {
    const result = request
        .post(inventoryCorrectionEndpoints.submit)
        .send(correction);

    if (onSuccess && onFail) {
        result
            .then((resp) => onSuccess(resp.body))
            .catch((err) => onFail(err))
    } else {
        return result
    }
}

const deleteInventoryCorrection = (correctionId, onSuccess, onFail) => {
    const result = request.delete(inventoryCorrectionEndpoints.delete(correctionId));

    if (onSuccess && onFail) {
        result
            .then((resp) => onSuccess(resp.body))
            .catch((err) => onFail(err))
    } else {
        return result
    }
};

const getBookingOrderNumber = (orderNumber, onSuccess, onFail) => {
    const result = request
        .get(inventoryCorrectionEndpoints.getBookingByOrderNumber(orderNumber))

    if (onSuccess && onFail) {
        result
            .then((resp) => onSuccess(resp.body))
            .catch((err) => onFail(err))
    } else {
        return result
    }

};

const moveAssetToDifferentBooking = (inventoryActivityId, orderNumber, onSuccess, onFail) => {
    const result = request
        .put(inventoryCorrectionEndpoints.moveAsset)
        .send({
            inventoryActivityId,
            orderNumber
        })

    if (onSuccess && onFail) {
        result
            .then((resp) => onSuccess(resp.body))
            .catch((err) => onFail(err))
    } else {
        return result
    }
};

export {
    getAllSupplierInventoryCorrections,
    updateInventoryCorrection,
    getBookingOrderNumber,
    moveAssetToDifferentBooking,
    submitInventoryCorrection,
    deleteInventoryCorrection,
    searchBuyerInventoryCorrections,
    searchBuyerCorrectionReview
}
